import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Footer from "../component/Footer";
import VisitorNavbar from "../component/VisitorNavbar";
import axios from "axios";
import { baseurl } from "../Baseurl";
import { toast } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";

const VerifyOtp = () => {
  const [searchParams] = useSearchParams();
  const encodedData = searchParams.get("data");

  // State variables
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [id, setId] = useState(null);
  const [showOtpFields, setShowOtpFields] = useState(false); // Show OTP input fields after requesting OTP
  const [emailOtp, setEmailOtp] = useState(""); // OTP input for email
  const [phoneOtp, setPhoneOtp] = useState(""); // OTP input for phone
  const [loading, setLoading] = useState(false); // Loading state for requests

  useEffect(() => {
    if (encodedData) {
      try {
        const decodedData = atob(decodeURIComponent(encodedData)); // Decode Base64
        const userData = JSON.parse(decodedData);
        setEmail(userData.email);
        setPhone(userData.phone);
        setId(userData.id);
      } catch (error) {
        console.error("Error decoding data:", error);
      }
    }
  }, [encodedData]);

  // 🔹 Request OTP for Email & Phone
  const requestOtp = async () => {
    try {
      setLoading(true);

      // Log the data before sending
      console.log("Sending OTP request with data:", { email, phone, id });

      
      const response = await axios.post(`${baseurl}request-otp`, { email, phone, id });
      
      if (response.data.success) {
        toast.success("OTP sent to your Email & Phone!");
        setShowOtpFields(true); // Show OTP input fields
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error requesting OTP:", error);
      toast.error("Failed to send OTP. Try again.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Verify OTP Submission
  const verifyOtp = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const response = await axios.post(`${baseurl}/verify-otp`, {
        email,
        phone,
        id,
        emailOtp,
        phoneOtp,
      });

      if (response.data.success) {
        toast.success("OTP Verified Successfully!");
        // Redirect user to dashboard or next step
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error("Invalid OTP. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <VisitorNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 justify-content-center">
              <div className="col-md-5">
                <div className="reviewcls">
                  <h4 className="review-form-heading">Verify OTP</h4>
                  <p className="payttl">
                    Please confirm your email and phone number before proceeding.
                  </p>
                  <p><b>Email:</b> {email}</p>
                  <p><b>Phone:</b> {phone}</p>
                  <hr />

                  {!showOtpFields ? (
                    // Step 1: Request OTP Button
                    <div className="text-center">
                      <button
                        className="btn btn-primary"
                        onClick={requestOtp}
                        disabled={loading}
                      >
                        {loading ? "Requesting OTP..." : "Request OTP On Email & Phone"}
                      </button>
                    </div>
                  ) : (
                    // Step 2: OTP Input Fields & Submit Button
                    <form className="contact-form text-center" onSubmit={verifyOtp}>
                      <div className="mb-3">
                        <label>Email OTP:</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Email OTP"
                          value={emailOtp}
                          onChange={(e) => setEmailOtp(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label>Phone OTP:</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Phone OTP"
                          value={phoneOtp}
                          onChange={(e) => setPhoneOtp(e.target.value)}
                          required
                        />
                      </div>
                      <button className="btn btn-success" type="submit" disabled={loading}>
                        {loading ? "Verifying..." : "Submit OTP"}
                      </button>
                    </form>
                  )}

                  <div className="mt-3 text-center">
                    <p>
                      Didn't receive the OTP?{" "}
                      <button className="btn btn-link p-0" onClick={requestOtp} disabled={loading}>
                        Resend OTP
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default VerifyOtp;
